export class SapObjectSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objectId",
            "baseName": "objectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "mode",
            "baseName": "mode",
            "type": "SapIngestionMode",
            "format": ""
        },
        {
            "name": "fromDate",
            "baseName": "fromDate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapObjectSelection.attributeTypeMap;
    }
    constructor() {
    }
}
